import { useState, useEffect, useContext } from 'react';

import { useFetch } from "../../hooks/useFetch"
import LoadSimple from "../LoadSimple"
import Modal from 'react-modal';
import ModalDeleteUSer from "./ModalDeleteUser";

import { capitalizeFirstLetter } from "../../utils/utils";
import { lang } from "../generales/traduction";

import ModalUpdatePassword from "./ModalUpdatePassword";
import { UserContext } from '../../context/UserContext';

const deleteUserModalStyles = {
    content: {
        top: '50%',
        left: '50%',
        background: '#ffffff !important',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        width: '30%',
        height: '20%',
        padding: '20px'
    },
};
const UserList = ({ languaje, mode, dataUsers, setDataUsers, handleChangEdit, setData, setLoading, setError, server, pageActual, limitList, dataList }) => {
    // const dataUsers=useFetch('cassia/users','',localStorage.getItem('access_token'),'GET',server)
    // console.log(dataUsers.data.data)
    const startLimit = limitList * pageActual - limitList;
    const [deleteUserModalOpen, setDeleteUserModalOpen] = useState(false);
    const [userSelected, setUserSelected] = useState({})

    const [changePassModalOpen, setChangePassModalOpen] = useState(false);
    const [adminNewPassword, setAdminNewPassword] = useState("");

    const { userPermissions } = useContext(UserContext);

    const PROTECTED_USERS = ["daniel.martinez", "hector.rodriguez", "mitzi.huerta", "dzavala", "luis.rocha", "andrea.tejeda"];
    const PROTECTED_DOMAINS = ["seguritechsistemas.com", "seguritech.com"];

    const isUserProtected = (email) => {
        if (!email) return false;
        const [user, domain] = email.toLowerCase().split('@');
        return PROTECTED_USERS.includes(user) && PROTECTED_DOMAINS.includes(domain);
    };

    // console.log(userSelected)
    function openDeleteUserModal() {
        setDeleteUserModalOpen(true);
    }

    function closDeleteUserModal() {
        setDeleteUserModalOpen(false);
    }
    const handledeleteUserClick = (data) => {

        openDeleteUserModal()
        setUserSelected(data)
        // Realiza las acciones deseadas al hacer clic en el marcador
    };

    useEffect(() => {
        buscar_cis();
    }, []);
    const buscar_cis = () => {
        // setLoadingCis(true)
        const fetchDataPost = async () => {
            try {
                const response = await fetch(
                    server.url +
                    "/api/v1/cassia/users",
                    {
                        method: "GET",
                        headers: {
                            "Content-Type": "application/json",
                            accept: "application/json",
                            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
                        },
                    }
                );
                if (response.ok) {
                    const data1 = await response.json();
                    // setLoadingCis(false)
                    // console.log(data1);
                    setDataUsers(data1);
                    // setCreateCisModalOpen(true)
                } else {
                    const data1 = await response.json();
                    throw new Error("Error en la solicitud");
                }
            } catch (error) {
                console.error(error);
            }
        };

        fetchDataPost();
    };
    return (
        <>
            <div className='cont-row-user-list'>
                {(dataUsers.loading) ? <div className='cont-load-user-list'><LoadSimple></LoadSimple></div> :
                    dataList
                        .slice(startLimit, parseInt(pageActual) * parseInt(limitList))
                        .map((elemento, indice) => (
                            <div className={"row-table-portafolio" + mode} key={indice}>

                                <div className='field-body-table-users field-nombre'>
                                    {elemento.name}
                                </div>
                                <div className='field-body-table-users field-correo'>
                                    {elemento.mail}
                                </div>
                                <div className='field-body-table-users field-rol'>
                                    {(elemento.roles.length == 0) ? '---' : elemento.roles[0].name}
                                </div>
                                <div className='field-body-table-users field-correo'>
                                    {elemento.groups.map(item => item.name).join(" - ")}
                                </div>
                                <div className='field-body-table-users field-acciones'>
                                    {userPermissions.some(p => p.module_name === "admin_update_password") && !isUserProtected(elemento.mail) && (
                                        <div className='cont-img-field-acciones'>
                                            <img
                                                className='img-field-acciones'
                                                src='/iconos/password-reset.png'
                                                title='Cambiar Contraseña'
                                                onClick={() => {
                                                    setUserSelected(elemento);
                                                    setAdminNewPassword("");
                                                    setChangePassModalOpen(true);
                                                }}
                                            />
                                        </div>
                                    )}
                                    <div className='cont-img-field-acciones'>
                                        <img className='img-field-acciones' src='/iconos/editar.png' title='Editar' name='Editar' user_id={elemento.user_id} onClick={() => handleChangEdit(elemento)} />
                                    </div>
                                    <div className='cont-img-field-acciones'>
                                        <img className='img-field-acciones' src='/iconos/delete.png' title='Eliminar' name='Eliminar' user_id={elemento.user_id} onClick={() => handledeleteUserClick(elemento)} />
                                    </div>
                                </div>
                            </div>
                        ))
                }
                {(dataList.length == 0) ? <div className='no-results'>
                    {capitalizeFirstLetter(lang[languaje]['sinResultados'])}
                </div> : ''}
            </div>
            <ModalUpdatePassword
                isOpen={changePassModalOpen}
                onClose={() => setChangePassModalOpen(false)}
                userSelected={userSelected}
                server={server}
                languaje={languaje}
                isUserProtected={isUserProtected}
            />
            <Modal
                isOpen={deleteUserModalOpen}
                // isOpen={true}
                // onAfterOpen={afterOpenExeption}
                onRequestClose={closDeleteUserModal}
                style={deleteUserModalStyles}
                contentLabel="Example Modal2"
            // shouldCloseOnOverlayClick={false}
            >
                <ModalDeleteUSer languaje={languaje} mode={mode} server={server} setData={setData} setLoading={setLoading} setError={setError} user={userSelected} closDeleteUserModal={closDeleteUserModal}></ModalDeleteUSer>
            </Modal>
        </>
    )
}

export default UserList